<img [ngClass]="pSize" [src]="logoUrl || basicLogoUrl">
